/**
 * Maneno design tokens
 *
 * Single source of truth for all spacing, typography and radius values
 * used by the ManenoLayout styled-component and Maneno page modules.
 * Colour values come from CSS custom properties defined in tokens.css
 * (:root) so they remain overridable at runtime.
 */

// ─── Typography ────────────────────────────────────────────────────────────────
export const MANENO_FONT = "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

export const MANENO_TYPE = {
  logoSize: "18px",
  logoWeight: 700,
  pageTitle: "20px",
  sectionTitle: "15px",
  cardTitle: "14px",
  body: "13px",
  bodySmall: "12px",
  small: "11px",
  xsmall: "10px",
  statNumber: "22px",
  weightRegular: 400,
  weightMd: 500,
  weightSemi: 600,
  weightBold: 700,
  weightBlack: 900
} as const;

// ─── Spacing ────────────────────────────────────────────────────────────────────
export const MANENO_SPACE = {
  pagePadding: "20px 28px",
  maxWidth: "1280px",
  cardGap: "14px",
  sectionGap: "20px",
  headerHeight: "56px",
  sidebarWidth: "240px"
} as const;

// ─── Border radius ──────────────────────────────────────────────────────────────
export const MANENO_RADIUS = {
  pill: "16px",
  pillLg: "20px",
  card: "8px",
  cardSm: "6px",
  bookCover: "6px",
  circle: "50%",
  badge: "4px",
  button: "6px"
} as const;

// ─── Shadows ────────────────────────────────────────────────────────────────────
export const MANENO_SHADOW = {
  card: "0 1px 2px rgba(15, 23, 42, 0.08)",
  cardHover: "0 4px 10px rgba(15, 23, 42, 0.12)",
  header: "0 1px 0 var(--color-header-border)",
  button: "0 1px 3px rgba(22, 91, 149, 0.16)"
} as const;
